import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Tweet a photo every time your mac wakes up with a simple hack",
  "description": "",
  "published": "2011-01-14T00:00:00.000Z",
  "redirect_from": ["/blog/tweet-a-photo-every-time-your-mac-wakes-up-with-a-simple-hack/swizec/1543"],
  "categories": "Uncategorized",
  "hero": "./img/Fdj3o.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`A few days ago there was a story on HackerNews about a guy who made a funky script to take a photo of himself every time he opened his computer. The original story was `}<a parentName="p" {...{
        "href": "http://benjamin-meyer-home.blogspot.com/2011/01/1-10-photos-every-day-starting-in-2006.html"
      }}>{`here`}</a>{`.`}</p>
    <p><figure parentName="p" {...{
        "className": "gatsby-resp-image-figure",
        "style": {
          "textAlign": "center",
          "fontStyle": "italic"
        }
      }}>{`
    `}<span parentName="figure" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "640px"
          }
        }}>{`
      `}<a parentName="span" {...{
            "className": "gatsby-resp-image-link",
            "href": "/static/ac893d76c711b88ff51ebf0d88f0269b/c08c5/Fdj3o.jpg",
            "style": {
              "display": "block"
            },
            "target": "_blank",
            "rel": "noopener"
          }}>{`
    `}<span parentName="a" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "74.88789237668162%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/svg+xml,%3csvg%20xmlns=\\'http://www.w3.org/2000/svg\\'%20width=\\'400\\'%20height=\\'300\\'%20viewBox=\\'0%200%20400%20300\\'%20preserveAspectRatio=\\'none\\'%3e%3cpath%20d=\\'M1%2023v22l3-1%203%201c1%201%202%200%204-2%203-3%203-3%206-2s3%203%202%208c-1%201-1%202%202%204l3%201%203-3%203-4%203-6c4-6%204-5%200-8-4-2-5-4-3-8%203-3%202-5-1-6-4-2-4-3-1-7%202-4%202-5-4-9-5-3-6-3-14-3H1v23M121%201c-2%202-1%204%204%206%202%201%203%202%202%203-1%204-1%205%201%206%203%201%204%203%201%206-1%202-1%202%201%204%203%203%203%203%202%206-3%204-2%204%201%207%206%203%208%204%2010%200%202-3%201-5-3-6-3-1-3-4-1-6s2-2%204-1a459%20459%200%200019%2011l-3%206-4-2-4-2-1%203c-3%204-3%205%203%207l4%203%203-2c1-3%202-3%204-2%202%200%203%200%204-3%202-2%203-3%204-2%204%201%205%201%207-2l3-2%203%202c5%203%204%203%2012-11l6-12-3-2c-5-3-5-3-9%204-3%206-5%207-8%205-1-1-1-1%201-4%202-4%202-4-14-13l-12-7c-1-2-36-1-37%200m146%202l-1%202%2011%207c2%200%205-4%205-6%200-5-13-8-15-3m29%200c6%204%206%205%203%208l-2%203-6-3-5-2-2%202c-3%204-3%204%205%209l6%204%202-2c3-2%206-3%208-1%201%201%202%201%204-2s3-3%205-2c3%201%203%204%200%208-4%205-4%206%203%2010l5%203%202-2%2011-17c0-1-1-2-3-2-5-3-5-4-1-10l3-6-22-1h-21l5%203m-76%2071l-7%203c-2%202-3%202-6%200-7-4-15-2-24%205-5%204-6%205-3%205l-2%202c-5%201-11%207-15%2013l-4%207a109%20109%200%2000-12%2020c-3%205-3%206-2%208l-1%203-2%206-3%205c-1%201-1%201%201%201s2%200%203%202c0%202-3%205-7%205h-3l1%206c0%207%203%2012%208%2015%202%201%200%209-2%2010l-1%202-1%201c-3-1-15%201-17%202-1%201%202%201%207%201%2011-1%2014-1%2014%203l3%205%202%206%203%204c3%203%202%204-9%205-7%200-7%201-7%204%200%201-1%202-3%202-10%203-30%2019-32%2025l-4%2010-8%2015-9%2015c-7%2011-10%2010%2037%2010%2041%200%2042%200%2042-2%203-7%2022-18%2026-15l4%202%206%202%204%201%203-3%204-6%204-6c3-3%2021-12%2024-12%202%200%2015%206%2022%2011l10%205c7%204%2010%206%2015%2015l4%208h117v-5c0-5%200-6-7-13l-21-30c-6-13-21-24-41-31-2-1-2-1-1-2%202-3-1-5-11-6-11-1-17-3-17-6l-2-5-2-4-2-2c-2-2%201-20%204-22s4-8%202-8c-4%200-6-10-3-12v-3l-4-7-6-13-6-9a163%20163%200%2000-12-19c0-2-24-25-27-26l-6-3h-18m-10%2032c-6%204-8%208-8%2015l-1%207a18%2018%200%2000-1%2010l10%201a999%20999%200%200123-2l8-2c7-1%207-4-1-12l-6-7c0-5-12-15-16-15-2%200-5%202-8%205m15%2047l-1%205-2%205-1%202c1%201%200%203-2%205l-3%203%205%201h14l3-2c3%200%202-2%200-4-2%200-3-2-4-7l-3-9c-2-2-5-1-6%201m13%203v2l1%201%201%202c0%204%204%208%208%207s4-1%204-3c0-3-2-5-6-5-6%200-5-1%201-1%207%200%2010-1%2010-2l-19-1m-33%202c-9%201-11%203-7%206%202%202%202%202%201%205%200%204%202%205%208%203%204-2%2010-7%208-7l-1-1c1-1%200-2-1-2-2-1-2-1%200-2l3-2h-11m38%2013c-1%200-2%201-1%204l-1%207c-1%202-1%202%203%202%204%201%205%201%206-3%200-2%201-3%202-3l1-2-2-4c0-2-2-2-8-1m-41%206c-3%204-3%205%201%208%203%203%206%204%2011%202%201-1%202%200%204%201%201%201%203%202%207%202%207%200%207%200%200-3l-4-3-1-2-3-4c-1-3-1-3-7-4-5%200-6%200-8%203m21%20103c-11%207-22%2017-13%2012a301%20301%200%200129-12l-3-3c-3-3-4-3-13%203\\'%20fill=\\'%23d3d3d3\\'%20fill-rule=\\'evenodd\\'/%3e%3c/svg%3e')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<picture parentName="a">{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/ac893d76c711b88ff51ebf0d88f0269b/ca0a1/Fdj3o.webp 223w", "/static/ac893d76c711b88ff51ebf0d88f0269b/75680/Fdj3o.webp 445w", "/static/ac893d76c711b88ff51ebf0d88f0269b/0ba47/Fdj3o.webp 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/webp"
              }}></source>{`
          `}<source parentName="picture" {...{
                "srcSet": ["/static/ac893d76c711b88ff51ebf0d88f0269b/853b2/Fdj3o.jpg 223w", "/static/ac893d76c711b88ff51ebf0d88f0269b/0a4fe/Fdj3o.jpg 445w", "/static/ac893d76c711b88ff51ebf0d88f0269b/c08c5/Fdj3o.jpg 640w"],
                "sizes": "(max-width: 640px) 100vw, 640px",
                "type": "image/jpeg"
              }}></source>{`
          `}<img parentName="picture" {...{
                "className": "gatsby-resp-image-image",
                "src": "/static/ac893d76c711b88ff51ebf0d88f0269b/c08c5/Fdj3o.jpg",
                "alt": "Fdj3o",
                "title": "Swizec's ugly mug",
                "loading": "lazy",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                }
              }}></img>{`
        `}</picture>{`
  `}</a>{`
    `}</span>{`
    `}<figcaption parentName="figure" {...{
          "className": "gatsby-resp-image-figcaption"
        }}>{`Swizec's ugly mug`}</figcaption>{`
  `}</figure></p>
    <p>{`I immediately liked the idea, but wanted to do something more with it. The only natural step was to take a photo and instead of storing it locally, just uploading it to some url and tweeting it. So last night I sat down for an hour of hacking and patched together a bunch of scripts and voila #TweetAWakeup was born.`}</p>
    <p>{`You can view the photos live on twitter via the #`}<a parentName="p" {...{
        "href": "http://twitter.com/#!/search?q=%23TweetAWakeup"
      }}>{`TweetAWakeup`}</a>{` hashtag.`}</p>
    <p>{`If you want to make something like this, here's a quick howto of as many steps as I remember. I guess someone could make a simple script to do this, but then it would lose some of its geeky appeal.`}</p>
    <p>{`Ok here's what you do:`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://dev.twitter.com/apps/new"
          }}>{`Register an app on Twitter`}</a>{`.`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://imgur.com/register/api_anon"
          }}>{`Get an imgur API key`}</a></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Install `}<a parentName="p" {...{
            "href": "http://www.bernhard-baehr.de/"
          }}>{`Sleepwatcher`}</a></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Install `}<a parentName="p" {...{
            "href": "http://www.intergalactic.de/pages/iSight.html"
          }}>{`iSight CLI Image Capture`}</a></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Download and install `}<a parentName="p" {...{
            "href": "https://github.com/marcel/twurl"
          }}>{`twurl`}</a>{` (you might have to update RubyGems with "gem update --system")`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Download `}<a parentName="p" {...{
            "href": "https://github.com/Swizec/random-coding/tree/TweetAWakeup"
          }}>{`my helper scripts`}</a></p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Authorize twurl as per instructions on `}<a parentName="p" {...{
            "href": "https://github.com/marcel/twurl"
          }}>{`github`}</a>{` (twurl authorize ...)`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`run "sudo launchctl load -w /Library/LaunchDaemons/de.bernhard-baehr.sleepwatcher-20compatibility-localuser.plist" (this makes sleepwatcher work)`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Edit ~/.wakeup and make it look something like this, obviously you should modify the path to suit your setup`}</p>
      </li>
      <li parentName="ol">
        <pre parentName="li"><code parentName="pre" {...{}}>{`#!/bin/bash

/bin/bash ~/Documents/random-coding/TweetAWakeup/TweetAWakeup.sh
`}</code></pre>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Go into TweetAWakeup/update.py and edit line 8 to match your imgur API key from step 2`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Go into TweetAWakeup/TweetAWakeup.sh and edit the paths to suit your setup`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`You can change what the tweet will look like on line 6 ... would be nice if you leave the hashtag :)`}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Run "twurl alias tweet /1/statuses/update.xml"`}</p>
      </li>
    </ol>
    <p>{`And you're done! Every time your mac wakes up from sleep it will take a photo with iSight, then wait 10 seconds and post it on twitter. The wait is there to give your computer supple time to connect to an internet.`}</p>
    <p>{`Obviously this whole thing is rather pointless, but I find it interesting. Maybe something awesome falls out over time and I get a neato introspection into my daily life ... or better yet, a hawt sexy girl with no top will forget about this and accidentally post her boobies all over the internet then much funs will ensue.`}</p>
    <p>{`PS: hopefully I didn't miss a step :)`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      